import { WafPrefix } from '../../shared/enums';
import { extractTextFromRichText } from './html-renderer-utility.service';
import { naturalOrderBy } from './natural-sort.service';
/**
 * Wrapper for naturalSort that removes HTML tags from rich text fields before sorting.
 * @param data - The array of objects to be sorted. (left unmutated)
 * @param sortDescriptors - An array of sort descriptors containing field and direction.
 * @returns A new array of sorted objects.
 */
export function orderByWithRichText(data: any[], sortDescriptors: { field: string, dir?: string; }[]): any[] {
    const dataWithTagsToRemove = data.map(row => ({ ...row }));
    sortDescriptors.forEach(sortDescriptor => {
        if (sortDescriptor.field.startsWith(WafPrefix.RichText)) {
            removeTagsForRichTextField(dataWithTagsToRemove, sortDescriptor.field);
        }
    });
    const orderedEditedRows = naturalOrderBy(dataWithTagsToRemove, sortDescriptors);
    const orderedOriginalRows: any[] = [];
    orderedEditedRows.forEach(orderedEditedRow => {
        const originalRow = data.find(row => row['id'] === orderedEditedRow['id']);
        orderedOriginalRows.push(originalRow);
    });
    return orderedOriginalRows;
}

function removeTagsForRichTextField(dataWithTagsToRemove: any[], field: string): void {
    dataWithTagsToRemove.forEach(row => {
        if (row[field]) {
            row[field] = extractTextFromRichText(row[field]) || row[field];
        }
    });
}
